import React from "react";
import { FooterStyle } from "./FooterStyle";

export default function Footer() {
  return (
    <FooterStyle>
      <div>
        <p>2020</p>
      </div>
    </FooterStyle>
  );
}
